<template>
    <div style="margin:10px 10px 0 10px;background-color: #EFF1F4;height: 100vh">
        <!--搜索-->
        <div class="el-card is-always-shadow" style="padding:20px 0 0 20px;margin-top: 10px;border-radius: 0">
            <el-form ref="searchForm" :model="searchForm" size="mini" inline>
                <el-form-item label="设备编号" prop="imei">
                    <el-input v-model="searchForm.imei" clearable/>
                </el-form-item>
                <el-form-item label="S/N" prop="sn">
                    <el-input v-model="searchForm.sn" clearable/>
                </el-form-item>
                <el-form-item label="社区" prop="name">
                    <el-select v-model="searchForm.hospital_id" filterable placeholder="请选择" clearable>
                        <el-option v-for="item in HospitalAllData" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型" prop="name">
                    <el-select v-model="searchForm.source" filterable placeholder="请选择" clearable>
                        <el-option label="005" value="1"></el-option>
                        <el-option label="105" value="2"></el-option>
                        <el-option label="201" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-button type="primary" size="mini" @click="onSearch" icon="el-icon-search">查询</el-button>
                <el-button type="primary" size="mini" @click="show_bind('bp')" icon="el-icon-search">设备记录</el-button>
            </el-form>
        </div>
        <div style="margin-top: 10px;height:calc(100vh - 165px);background-color: #ffffff;">
            <!--数据-->
            <div style="padding: 10px">
                <el-table :row-style="{height:0+'px'}" :cell-style="{padding:5+'px'}" :data="tableData" border
                          style="width: 100%;"
                          header-cell-style="background-color: #f5f5f5; padding:15px 0;font-weight:500;color:#999999 ">
                    <el-table-column prop="id" label="序号" width="66" align="center">
                    </el-table-column>
                    <el-table-column prop="imei" label="设备编号" width="240" align="center"></el-table-column>
                    <el-table-column prop="sn" label="S/N" align="center"></el-table-column>
                    <el-table-column prop="hospital_name" label="设备分类" align="center" min-width="150">
                        <template slot-scope="scope">
                            {{sourceInfo[scope.row.source]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospital_name" label="模式" align="center" min-width="150">
                        <template slot-scope="scope">
                            {{keyInfo[scope.row.is_key]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="day_i" label="日间频率" width="88px" align="center"></el-table-column>
                    <el-table-column prop="night_i" label="夜间频率" width="88px" align="center"></el-table-column>
                    <el-table-column prop="night_start" label="夜间开始" width="88px" align="center"></el-table-column>
                    <el-table-column prop="night_end" label="夜间结束" width="88px" align="center"></el-table-column>
                    <el-table-column prop="Systolic_alert" label="高压阈值" width="88px" align="center"></el-table-column>
                    <el-table-column prop="Diastolic_alert" label="低压阈值" width="88px" align="center"></el-table-column>
                    <el-table-column prop="bat" label="电量(%)" width="88px" align="center"></el-table-column>
                    <el-table-column prop="user.mobile" label="语音" width="88px" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.is_voice=='0'" type="success" size="mini">开启</el-tag>
                            <el-tag v-if="scope.row.is_voice=='1'" type="danger" size="mini">关闭</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospital_name" label="社区" align="center" min-width="150">
                    </el-table-column>

                    <el-table-column prop="hospital_name" label="是否绑定用户" align="center" min-width="150">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.uid>0" @click="unBindUser(scope.row)" type="success" size="mini">
                                已绑定
                            </el-tag>
                            <span v-else>未绑定</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="date" label="操作" align="center" width="118px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="show_detail(scope.row)">修改</el-button>
                            <el-button type="text" size="small" @click="show_bind('kkbp',scope.row)">绑定记录</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <!--分页-->
            <div style="margin-top: 25px;text-align: center">
                <el-pagination layout="total, sizes, prev, pager, next" :current-page="page" :page-sizes="[15, 25, 50]"
                               :page-size="pagesize" :total="total" @size-change="handleSizeChange"
                               @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="编辑" :visible.sync="userDialog">
            <el-form ref="form" :model="form" label-width="150px" size="small">
                <el-row>
                    <el-form-item prop="hospital_id" label="绑定社区医院">
                        <el-select v-model="writeForm.hospital_id" placeholder="请选择" clearable filterable size="small">
                            <el-option value="0" label="未绑定"/>
                            <el-option v-for="item in HospitalAllData" :key="item.id" :label="item.name"
                                       :value="item.id"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="writeForm.source==3" prop="is_voice" label="设备模式">
                        <el-radio-group v-model="writeForm.usb">
                            <el-radio-button label="1">USB</el-radio-button>
                            <el-radio-button label="0">4G</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="设备编号" prop="imei">
                        <el-input v-model="writeForm.imei" clearable/>
                    </el-form-item>
                    <el-form-item label="S/N" prop="sn">
                        <el-input v-model="writeForm.sn" clearable/>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item prop="day_i" label="日间频率">
                        <el-input clearable v-model="writeForm.day_i" placeholder=""/>
                    </el-form-item>
                    <el-form-item prop="night_i" label="夜间频率">
                        <el-input clearable v-model="writeForm.night_i" placeholder=""/>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item prop="night_start" label="夜间开始">
                        <el-input clearable v-model="writeForm.night_start" placeholder=""/>
                    </el-form-item>
                    <el-form-item prop="night_end" label="夜间结束">
                        <el-input clearable v-model="writeForm.night_end" placeholder=""/>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item prop="Systolic_alert" label="高压阈值">
                        <el-input clearable v-model="writeForm.Systolic_alert" placeholder=""/>
                    </el-form-item>
                    <el-form-item prop="Diastolic_alert" label="高压阈值">
                        <el-input clearable v-model="writeForm.Diastolic_alert" placeholder=""/>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item prop="hospital_id" label="加密模式" >
                        <el-select v-model="writeForm.is_key" placeholder="请选择" clearable filterable size="small">
                            <el-option value="0" label="不加密"/>
                            <el-option v-if="writeForm.source==2" value="1"  label="单向认证"/>
                            <el-option v-if="writeForm.source==2||writeForm.source==3" value="2" label="双向认证"/>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="is_voice" label="语音播报">
                        <el-radio-group v-model="writeForm.is_voice">
                            <el-radio-button label="1">关闭</el-radio-button>
                            <el-radio-button label="0">开启</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-row>

                <el-row style="width: 100%;flex-direction: row;justify-content: end">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">提交</el-button>
                    </el-form-item>
                </el-row>
            </el-form>

        </el-dialog>
        <el-dialog title="设备绑定记录" :visible.sync="bindLogShow">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="单次记录" name="first">
                    <el-table :data="logList" style="width: 100%">
                        <el-table-column prop="uid" label="用户编号" width="180">
                        </el-table-column>
                        <el-table-column prop="user.name" label="姓名" width="180">
                        </el-table-column>
                        <el-table-column prop="client_id" label="设备号" width="180">
                        </el-table-column>
                        <el-table-column prop="start_time" label="开始时间" width="180">
                        </el-table-column>
                        <el-table-column prop="end_time" label="结束时间" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="动态记录" name="second">
                    <el-table :data="logList" style="width: 100%">
                        <el-table-column prop="uid" label="用户编号" width="180">
                        </el-table-column>
                        <el-table-column prop="user.name" label="姓名" width="180">
                        </el-table-column>
                        <el-table-column prop="client_id" label="设备号" width="180">
                        </el-table-column>
                        <el-table-column prop="start_time" label="开始时间" width="180">
                        </el-table-column>
                        <el-table-column prop="end_time" label="结束时间" width="180">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>

</template>
<style>
    .el-row {
        display: flex;
    }
</style>
<script>
    import request from "../../plugins/axios";

    export default {
        data() {
            return {
                activeName: 'first',
                bindLogShow: false,
                bioType: '',
                detail: [],
                logList: [],

                deviceData: [
                    {
                        value: '1',
                        label: '血糖血压测试仪'
                    },
                    {
                        value: '2',
                        label: '蓝牙通话手表'
                    },
                    {
                        value: '3',
                        label: '健康体脂秤'
                    },
                ],
                hrole: '',
                selectKey: [],

                //用户管理
                searchForm: {
                    hospital_id: '',
                    imei: '',
                    sn: ''
                },
                writeForm: {},
                HospitalAllData: [],//所有社区
                RoleAllData: [],//所有角色
                user_form: {
                    curd: '',
                    mobile: '',
                    info: '',
                    id: '',
                },
                userDialog: false,
                page: 1,
                total: 0,
                pagesize: 15,
                tableData: [],
                sourceInfo: ['', '005', '新赛弘', '自研'],
                keyInfo: ['不开启', '单向认证', '双向认证'],


            };
        },
        components: {},
        created() {
            let that = this
            let uid = that.getQueryString('uid')
            if (uid && uid > 0) {

                that.searchForm.phone = localStorage.getItem('usphone')
            }
        },
        mounted() {
            let that = this
            that.getUserData();
            that.getHospitalAllData();
            this.hrole = localStorage.getItem('hrole')

        },
        methods: {
            //解绑用户
            unBindUser(row) {
                let that = this
                let imei = row.imei

                that.$confirm('确认要解绑用户吗，此操作不可恢复?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: "/hospital/News/un_bind_user",
                        data: {
                            imei: imei
                        },
                    }).then((ret) => {
                        if (ret.code == 1) {

                            that.getUserData();
                            that.$notify({
                                title: '提示',
                                message: ret.msg,
                                type: 'success'
                            });

                        } else {
                            that.$notify({
                                title: '提示',
                                message: ret.msg,
                                type: 'warning'
                            });
                        }
                    });
                }).catch(() => {
                    that.$notify({
                        title: '提示',
                        message: "取消解绑",
                        type: 'warning'
                    });
                });


                console.log(row.imei)
            },
            //切换
            handleClick(e) {
                let that = this
                let type = 1;
                if (e.name == 'second') {
                    type = 2;
                }
                that.get_bind_data(type)
            },
            show_bind(type, row) {
                let that = this

                that.bioType = type;
                that.detail = row
                that.activeName = 'first'
                that.get_bind_data(1)
                that.bindLogShow = true
            },
            get_bind_data(type) {
                let that = this
                let bioType = that.bioType
                let client_id = ''
                if (bioType == 'bp') {
                    client_id = that.searchForm.imei
                } else {
                    client_id = that.detail.imei
                }
                request({
                    url: "/hospital/News/get_bind_log",
                    data: {
                        client_id: client_id,
                        type: type
                    },

                }).then((ret) => {
                    that.logList = ret.data
                });
            },

            onSubmit() {
                let that = this
                let writeForm = that.writeForm
                request({
                    url: "/hospital/News/user_saihong_gprs_write/edit/" + writeForm.id,
                    data: writeForm,

                }).then((ret) => {
                    if (ret.code == 1) {
                        that.userDialog = false;
                        that.onSearch()
                    } else {

                    }
                });
            },
            show_detail(row) {
                let that = this

                that.writeForm = row

                that.userDialog = true
            },
            //获取url参数
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            //用户数据
            userData(row) {
                console.log('')
                localStorage.setItem('usphone', row.user.mobile)
                localStorage.setItem('usdevice', row.device_name)
                window.open(this.$router.resolve({path: "/admin/data?uid=1"}).href, "_blank");
            },
            //用户开始
            getUserData(page) {
                let that = this
                let data = that.searchForm
                data.pagesize = that.pagesize
                data.page = page ? page : 1;
                data.token = localStorage.getItem('token')
                request({
                    url: "/hospital/News/user_saihong_gprs/list",
                    data: data,

                }).then((ret) => {
                    if (ret.code == 1) {
                        this.tableData = ret.data.list
                        that.total = ret.data.total
                    } else {

                        return false
                        location.href = "/"
                    }
                });
            },
            //获取所有社区
            getHospitalAllData() {
                let that = this
                request({
                    url: "/hospital/News/hospital_opt",
                    data: {pageSize: 1000, page: 1},
                }).then((ret) => {
                    if (ret.code == 1) {
                        this.HospitalAllData = ret.data
                    }
                });
            },
            //用户查询
            onSearch() {
                let that = this.getUserData();
            },

            handleSizeChange(pagesize) {
                this.pagesize = pagesize;
                this.getUserData(1);
            },
            handleCurrentChange(page) {
                this.getUserData(page);
            }
        },
    };
</script>
